import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { root } from '../../../../../../../../../store/constants';
import { CLASS_USER_SETTINGS } from '../../../../../../../dialogs/userSettings/constants';

export const onOpenSettings = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        root.App.controller.openUserSettings();
        const interval = setInterval(() => {
            const section = document.querySelector(`.${CLASS_USER_SETTINGS}-section--notifications`);
            if (section) {
                clearInterval(interval);
                section.scrollIntoView();
                section.classList.add(`${CLASS_USER_SETTINGS}-section--highlight`);
                setTimeout(() => {
                    section.classList.remove(`${CLASS_USER_SETTINGS}-section--highlight`);
                }, 1700);
            }
        }, 200);
    };
    return action;
};
